import { listAgentMerchant } from '@/api/settle'
import { getProvinceAlipay, getCityAlipay, getAreaAlipay, getBankList, getAreaCode, getBranch } from '@/api/global'

export default {
  listAgentMerchant,
  getProvinceAlipay,
  getCityAlipay,
  getAreaAlipay,
  getBankList,
  getAreaCode,
  getBranch
}
